var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToastSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 188,
    viewBox: "0 0 188 188",
    width: 188,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 94,
    fill: "#1ab759",
    r: 94
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m82.6413 128.586c-1.9512 0-3.8154-.78-5.1916-2.177l-26.8675-27.3049c-2.8178-2.8688-2.7814-7.4704.0874-10.2956 2.8688-2.8104 7.4778-2.7814 10.2956.0874l21.465 21.8141 44.4078-48.9074c2.716-2.9779 7.318-3.189 10.281-.4949 2.978 2.7014 3.196 7.3029.495 10.2882l-49.5845 54.6081c-1.3469 1.486-3.2401 2.345-5.2424 2.389-.051-.007-.0947-.007-.1458-.007z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastSuccessIcon);
export default __webpack_public_path__ + "static/media/toast-success-icon.4bf9282865fcdb5c19fff5306165a37b.svg";
export { ForwardRef as ReactComponent };